import { Col } from '@paypalcorp/pp-react'
import React, { ReactNode } from 'react'
import iconCapStyles from './iconCap.module.css'

interface LinkProps {
  key: number | string
  url: string
  title: string
}

interface IconCapProps {
  links: LinkProps[]
  title: string
  description: string
  icon: ReactNode | ReactNode[]
}

const IconCap: React.FC<IconCapProps> = ({
  icon,
  title,
  description,
  links,
}) => {
  return (
    <Col className="floatCol">
      <div className={iconCapStyles.iconCapWrapper}>
        <div className={iconCapStyles.iconCapContainer}>
          <div className={iconCapStyles.iconCapIconWrapper}>
            <div className={iconCapStyles.iconCapIconContainer}>{icon}</div>
          </div>
        </div>
        <div className={iconCapStyles.iconCapBodyWrapper}>
          <h4 className={iconCapStyles.iconCapHeader}>{title}</h4>
          <p className={iconCapStyles.iconCapDescription}>{description}</p>
          {links.map(({ key, title, url }) => {
            return (
              <span key={key} className={iconCapStyles.iconCapLinkWrapper}>
                <a href={url} className={iconCapStyles.iconCapLink}>
                  {title}
                </a>
              </span>
            )
          })}
        </div>
      </div>
    </Col>
  )
}

IconCap.displayName = 'IconCap'

export default IconCap
